import columns from '../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';

let replacedDate;
export function getNavigationOptions(rowInfo, index) {
  if (index > 0) {
    const date = rowInfo.original.mrdRegistration.registrationDate[index];
    replacedDate = date.toString().replace('/', ' ');
  }
  const currentDatetime = new Date(replacedDate);
  const formattedDate = `${currentDatetime.getFullYear()}-${currentDatetime.getMonth() + 1}-${currentDatetime.getDate()}`;
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.OPERATIONAL_ANALYSIS.id,
    mainReportId: ReportDefinitions.HANDLER_MONITORING.id,
    requestParams: {
      date: true,
      originExchangeOffices: [rowInfo.row['mrdRegistration.mrdImpc']],
      destinationExchangeOffices: [],
      direction: ReportDefinitions.OPERATIONAL_ANALYSIS.reportDirections[0],
      mrdHandlerId: rowInfo.original.mrdRegistration.mrdHandlerId[index],
      period: {
        from: formattedDate,
        to: formattedDate,
      },
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    MultilineColumn,
    MultilineDateColumn,
    MultilineNumberColumn,
    MultilineNumberNavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'MRD registration',
      columns: [
        new TextColumn('MRD IMPC', 'mrdRegistration.mrdImpc'),
        new MultilineColumn('Handler', 'mrdRegistration.handler'),
        new MultilineDateColumn('Registration date', 'mrdRegistration.registrationDate'),
        new MultilineNumberColumn('Handovers', 'mrdRegistration.handovers'),
        new MultilineNumberNavigationColumn(new NonZeroNumberColumn('Labels', 'mrdRegistration.labels'), getNavigationOptions),
        new MultilineNumberColumn('Flight from list', 'mrdRegistration.flightFromList'),
        new MultilineNumberColumn('Flight manual', 'mrdRegistration.flightManuel'),
        new MultilineNumberColumn('Carrier known mixed', 'mrdRegistration.carrierKnownMixed'),
        new MultilineNumberColumn('Mixed carrier', 'mrdRegistration.mixedCarrier'),
        new MultilineNumberColumn('Unknown', 'mrdRegistration.unknown'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new MultilineNumberColumn('Denested', 'receptacles.denested'),
        new MultilineNumberColumn('Attributed', 'receptacles.attributed'),
      ],
    },
  ];
};
